export default "__VITE_ASSET__Bl44EfM6__"